import { useContext } from 'react';
import { TableActionsContext } from '../../context';

export const useTableActionsContext = () => {
  const context = useContext(TableActionsContext);
  if (!context) {
    throw new Error('useTableActionsContext must be used within a TableActionsProvider');
  }
  return context;
};
